import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const UserClientContactListPage = lazy(() => import('../views/list/UserClientContactListPage'));

export function UserClientContactListPageLazy() {
	return (
		<PageSuspense>
			<UserClientContactListPage />
		</PageSuspense>
	);
}
